module.exports = __webpack_public_path__ + "static/media/Logo.93c802e5.jpg";